import AccessDenied from './container';

export default AccessDenied;
